import App from '~/core/app';
import { collection, state, computed } from './state';
// import actions from './actions';
import * as actions from './actions'
import { ICore } from '~/core/core'; // type from the future
import { EventProto } from './interfaces';
const core = App.Core<ICore>(); // grab sister controller

const events = App.Controller({
    name: 'events',
    state: {
        ...state,
        ...computed
    },
    collection,
    actions,
    events: App.EventGroup((newEvent) => ({
        update: newEvent<{eventId: number, type?: 'delete'|'update', persist?: boolean, payload: EventProto}>(),
        remote_update: newEvent<{eventId: number, type?: 'delete'|'update', persist?: boolean, payload: EventProto}>(),
        reloadTree: newEvent<void>()
    }))
}).root(actions)

export default events as typeof events & typeof actions;